import React, {Component} from 'react';
import mbrinc from '../css/images/MooreBenefitResources_Inc.jpg';

class Services extends Component {
  render() {
    return (
      <div id="services">
          <h4 className="text-center font-weight-bold section-title">Core Services</h4>
    <div className="row">
    <div id="services-image" className='col-md-6'>
      <img src={mbrinc} alt="MooreBenefitResourcesInc" className="img-fluid float-left" />
    </div>
  <div className="col-md-6 services-text">
  <h4>
    <span className="font-weight-bold services-titles">Consulting & Strategic Planning:</span>
  </h4>
  <p className="services-text-items">Benefits strategy design, marketplace updates, benchmarking, plan performance reviews, complete benefits program analysis.</p>
  <h4>
    <span className="font-weight-bold services-titles">Vendor Selection & Implementation:</span> 
  </h4>
  <p className="services-text-items">Facilitate vendor selection, provide comprehensive report of vendor proposals, network discount and disruption analysis for self-insured plans, and provide alternative cost of goods sold analysis for clients willing to be on the cutting edge of benefits delivery.</p>
  <h4>
    <span className="font-weight-bold services-titles">Renewal Planning & Negotiation:</span>
  </h4>
  <p className="services-text-items">Set renewal strategy, evaluate competitiveness of current carrier fees, rates and services, determine need to conduct vendor selection, manage renewal process.</p>
  <h4>
    <span className="font-weight-bold services-titles">Financial Modeling:</span> 
  </h4>
  <p className="services-text-items">Provide plan design options, contribution modeling, cost impact and multi-year projections to support business planning, risk and stop-loss analysis.</p>
  <h4>
    <span className="font-weight-bold services-titles">Vendor & Plan Management:</span>
  </h4>
  <p className="services-text-items">Manage claim, enrollment, and administrative issues to resolution on behalf of our client and employees.</p>
  <h4>
    <span className="font-weight-bold services-titles">Compliance & Legislative Support:</span> 
  </h4>
  <p className="services-text-items">Ensure that client’s plans are compliant, address legal questions and provide regular compliance updates.</p>
  <h4>
    <span className="font-weight-bold services-titles">Employee Wellness Solutions:</span> 
  </h4>
  <p className="services-text-items">Evaluate and recommend strategy, incentives and vendors for wellness program components if necessary – e.g. biometric screenings, health assessments, corporate wellness challenges, health fairs.</p>
  <h4>
    <span className="font-weight-bold services-titles">Communications & Enrollment:</span> 
  </h4>
  <p className="services-text-items">Develop employee communication materials and benefit technology alternatives, conduct employee enrollment presentations, coordinate annual enrollment process.</p>
  </div>
</div>
      </div>
    )
  }
}

export default Services;



// WEBPACK FOOTER //
// ./src/components/Services.js